<button class="info-btn" (click)="onInfoClick()" aria-label="Info">
  <img [src]="iconSrc()" alt="" [attr.width]="size" [attr.height]="size" />
</button>

@if (!opensPage) {
  <app-info-modal
    #modal
    [title]="'Hinweis'"
    [actionLabel]="'Verstanden'"
    (action)="onInfoClose()"
    (closed)="onInfoClose()"
  ></app-info-modal>
}
